export const PRIORITY_SECTION_KEY = 'PRIORITY';
export const TAGS_PRIORITY = 'TAGS';
export const DEAL_SCORE_PRIORITY = 'DEAL_SCORE';
export const PRIORITY_PRIORITY = 'PRIORITY';